import { render, staticRenderFns } from "./KeyfeatureSliderMobile.vue?vue&type=template&id=3579f4da&scoped=true&"
import script from "./KeyfeatureSliderMobile.vue?vue&type=script&lang=js&"
export * from "./KeyfeatureSliderMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3579f4da",
  null
  
)

export default component.exports